var _path, _rect, _rect2, _rect3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNoService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 177,
    viewBox: "0 0 140 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8185 12.4801C66.441 8.15489 72.559 8.15489 74.1815 12.4801L116.762 125.994C117.988 129.263 115.572 132.75 112.081 132.75H26.9193C23.4281 132.75 21.0117 129.263 22.2378 125.994L64.8185 12.4801Z",
    fill: "#E77523"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 84,
    width: 84,
    height: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 43,
    width: 54,
    height: 20,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 126,
    width: 140,
    height: 7,
    rx: 2,
    fill: "#E77523"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 126.5,
    x2: 116,
    y2: 126.5,
    stroke: "#B65A18"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.9155,
    y1: 128.635,
    x2: 65.2541,
    y2: 12.7211,
    stroke: "#E77523"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 116.838,
    y1: 126.728,
    x2: 74.3362,
    y2: 14.25,
    stroke: "#E77523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoService);
export default __webpack_public_path__ + "static/media/ic-no-service.93688d33af432aac656019eb7c4d91fb.svg";
export { ForwardRef as ReactComponent };